window.qdConfigLoader = fetch(`${import.meta.env.VITE_CONFIGURATION_FILE}?rand=${Math.random()}`)
